import axios from "axios";
import { attachBearerToken, rejectAsJcnError } from "./utils/apiInterceptors";

// Control-plane REST client: POST /loginDash, POST /verifyToken and
// GET /feature-flags — the requests that establish the session and DECIDE the
// backend target. It is pinned to the env (build-time) backend and
// deliberately does NOT read utils/backendOverride: once a session is routed
// to the Mongo backend, a failing Mongo host must not be able to log the user
// out (verifyToken) or downgrade the flag read that chose it.
//
// Everything else uses the main client in ./axios.js.
const controlPlaneApi = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API}`,
});

controlPlaneApi.interceptors.request.use((config) => {
  attachBearerToken(config);
  // eslint-disable-next-line no-param-reassign
  config.baseURL = `${process.env.REACT_APP_REST_API}`;
  return config;
});

controlPlaneApi.interceptors.response.use((response) => response, rejectAsJcnError);

export default controlPlaneApi;
